import images from "@assets/logo/images";

// ─── Cookie Keys ────────────────────────────────────────────────
export const NPS_SURVEY_KEY = "nps_survey_key"; // Last surveyKey seen from the API — a new value starts a fresh cycle
export const NPS_DISMISS_COUNT = "nps_dismiss_count";
export const NPS_NEXT_SHOW_AT = "nps_next_show_at";

// ─── Constants ──────────────────────────────────────────────────
export const ONE_DAY_MS = 24 * 60 * 60 * 1000;
export const THIRTY_DAYS_MS = 30 * ONE_DAY_MS;
// export const SNOOZE_DURATION_MS = 10 * 60 * 1000; // 10 minutes for testing, 2 days in production
export const SNOOZE_DURATION_MS = 2 * ONE_DAY_MS;
export const CYCLE_COOKIE_TTL_MS = 365 * ONE_DAY_MS;
export const MAX_DISMISSALS = 2;
// export const POLL_INTERVAL_MS = 1 * 60 * 1000; // 1 minute for testing, 30 minutes in production
export const POLL_INTERVAL_MS = 30 * 60 * 1000;

// ─── Types ──────────────────────────────────────────────────────
export interface IFormValues {
  score: number | null;
  feedback: string;
}

export const emojis = [
  { id: 1, label: "never", icon: images.neverImg },
  { id: 2, label: "unlikely", icon: images.unlikelyImg },
  { id: 3, label: "maybe", icon: images.maybeImg },
  { id: 4, label: "likely", icon: images.likelyImg },
  { id: 5, label: "absolutely", icon: images.absolutelyImg },
];
